import { EChartsOption } from "echarts";
import { Box, Container } from "@mui/material";
import { RopChart } from "../../../../main/components/RopChart";
import { generateColorArray } from "./GeneratedEnergyCharts";
import { EmptyTable } from "../../../clients/components/EmptyState";
import { Perdas } from "../../types";

const OUTROS_GANHOS_SLICE_COLOR = "#2e7d32";

export default function LossDiagramReportChart(props: { perdas: Perdas }) {
  const { perdas } = props;

  const outrasMWh = perdas?.outrasPerdasMWh ?? 0;
  /** Negativo = outros ganhos (mantém alinhado ao diagrama de cascata do dashboard). */
  const outrasComoGanho = outrasMWh < 0;

  const options: EChartsOption = {
    title: {
      text: "Diagrama de Perdas",
      textStyle: {
        fontSize: 12,
      },
      subtext: "Distribuição das perdas de energia por categoria durante o período analisado",
      subtextStyle: {
        fontSize: 12,
        color: "#aaa",
      },
    },
    backgroundColor: "transparent",
    color: generateColorArray(6),
    series: [
      {
        name: "Diagrama de Perdas",
        type: "pie",
        radius: ["25%", "50%"],

        top: "-13%",
        bottom: "-25%",
        itemStyle: {
          borderRadius: 8,
          borderColor: "#fff",
          borderWidth: 0,
        },
        label: {
          color: "#FFF",
          formatter: "{b} {d}%, {c} MWh",
        },
        percentPrecision: 2,

        data: [
          {
            name: "Inversores",
            value: perdas?.perdaDosInversoresMWh ?? 0,
          },
          {
            name: "Trafo",
            value: perdas?.perdaDoTrafoMWh ?? 0,
          },
          {
            name: "Indisponibilidade",
            value: perdas?.perdaPorIndisponibilidadeMWh ?? 0,
          },
          {
            name: "Circuito",
            value: perdas?.perdaNoCircuitoMWh ?? 0,
          },
          outrasComoGanho
            ? {
              name: "Outros ganhos",
              value: Math.abs(outrasMWh),
              itemStyle: {
                color: OUTROS_GANHOS_SLICE_COLOR,
              },
            }
            : {
              name: "Outras perdas",
              value: outrasMWh,
            },
        ],

        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      },
    ],
  };

  const hasData =
    perdas?.outrasPerdasMWh ||
    perdas?.perdaDoTrafoMWh ||
    perdas?.perdaDosInversoresMWh ||
    perdas?.perdaNoCircuitoMWh ||
    perdas?.perdaPorIndisponibilidadeMWh;

  return (
    <>
      {hasData ? (
        <Container
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "90%",
            width: "100%",
          }}
        >
          <RopChart option={options} />
        </Container>
      ) : (
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <EmptyTable title="Nenhum dado encontrado!" />
        </Box>
      )}
    </>
  );
}
